import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteInsuranceInformation: Map<string, ConfirmationData> = new Map([
    ["a0f3eeb9-79df-4a63-abfb-44a75731c672|b404adb7-9675-4ef2-91a2-e8029f127e9f", { label: "Sim/Não" }],
    ["3777f36c-2407-4755-b716-fe76f89b8119|a4b17cd9-d538-4e7d-82a9-61c280a835da", { label: "Sim/Não" }],
    ["02496274-2be7-4022-942e-48070a8f08f0", { hiddenAll: true }],
    ["09641277-1f64-4375-a7a1-0be61587bba0|29e42fe5-41b3-493b-bff4-97b1fd018aa6", { label: "Sim/Não" }],

]);



